
import Button from '../../../components/base/Button';

export default function ServicesCTA() {
  return (
    <section className="py-20 bg-gradient-to-r from-red-600 to-red-700 text-white relative overflow-hidden">
      <div className="absolute inset-0 bg-black/10"></div>
      <div className="relative container mx-auto px-4 text-center">
        <h2 className="text-4xl md:text-5xl font-bold mb-6">
          Need a Reliable Fire Safety Partner?
        </h2>
        <p className="text-xl mb-8 max-w-2xl mx-auto">
          Contact FlameGuardQA today for professional fire protection services 
          that meet QCDD standards and keep your property safe.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button 
            variant="secondary" 
            size="lg"
            className="bg-white text-red-600 hover:bg-gray-100"
          >
            Get Free Quote
          </Button>
          <Button 
            variant="outline" 
            size="lg"
            className="border-white text-white hover:bg-white hover:text-red-600"
          >
            Schedule Consultation
          </Button>
        </div>
        
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="text-center">
            <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4">
              <i className="ri-phone-line text-2xl"></i>
            </div>
            <h4 className="font-semibold mb-2">Call Us</h4>
            <p className="text-red-100">+974 [Phone Number]</p>
          </div>
          <div className="text-center">
            <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4">
              <i className="ri-mail-line text-2xl"></i>
            </div>
            <h4 className="font-semibold mb-2">Email Us</h4>
            <p className="text-red-100">info@flameguardqa.com</p>
          </div>
          <div className="text-center">
            <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4">
              <i className="ri-map-pin-line text-2xl"></i>
            </div>
            <h4 className="font-semibold mb-2">Visit Us</h4>
            <p className="text-red-100">Doha, Qatar</p>
          </div>
        </div>
      </div>
    </section>
  );
}